import React from 'react';
import { useFormContext } from 'react-form';
import { createUseStyles } from 'react-jss';
import { ActionButton } from '../../atoms';
const getStyles = createUseStyles({
    root: {
        marginTop: 8
    }
});
const ManagedSubmitButton = (props) => {
    const { meta } = useFormContext();
    const styles = getStyles();
    const { isSubmitting, fieldsAreValidating, canSubmit } = meta;
    // TODO: add a scroll wheel at some point
    console.log('loading:', isSubmitting || fieldsAreValidating);
    return (React.createElement(ActionButton, { className: styles.root, type: 'submit', disabled: !canSubmit, ...props }));
};
export default ManagedSubmitButton;
//# sourceMappingURL=ManagedSubmitButton.js.map